export const CHECK_IN_TYPE = ['未签到', '到课', '请假', '迟到', '旷课']

export const QUANTITY_NAME_S = localStorage.getItem('language') == 'CN' ? ['天', '次', '小时'] : ['Day', 'Lesson', 'Hour']

export const QUANTITY_NAME_C = localStorage.getItem('language') == 'CN' ? ['天', '次', '次'] : ['', '', '']

export const UNIT_NAME_C = ['期', '次', '次']

export const COST_RULE = localStorage.getItem('language') == 'CN' ? ['课程时间结束后自动算课消', '课程签到后算课消'] :
['Lesson counts as completion after end date', 'Lesson counts as completion after attending']

export const ABSENT_RULE = localStorage.getItem('language') == 'CN' ? ['旷课不算课消', '旷课算消课'] : ['Absence (without notice) counts as incompletion', 'Absence (without notice) counts as completion']

export const CANCEL_RULE = localStorage.getItem('language') == 'CN' ? ['请假不算消课', '请假算消课'] :
['Absence (with excuse) counts as incompletion' , 'Absence (with excuse) counts as completion']

export const CLASS_TYPE_STATE = [['已归档', '当期班级'], ['已归档', '当期私课']]

export const STUDENT_STATE = ['', '当期学员', '未排班学员', '在读学员', '往期学员', '待续费学员']

export const CHARGE_TYPE = ['按期收费', '按次收费', '按课时收费']

export const CHARGE_REMINDER_TYPE = localStorage.getItem('language') == 'CN' ? ['按日期消耗完', '按课次数消耗完','按课时数消耗完'] :
['End Date', 'End Lesson','End Lesson Hour']

export const PAYMENT_METHOD = localStorage.getItem('language') == 'CN' ? ['现金', '信用卡', '支票', '转账', '校内钱包', 'ClassTopBase 钱包', '微信扫码器支付', '支付宝扫码器支付', '微信网页支付', '支付宝网页支付', '微信转账', '支付宝转账'] : ['Cash', 'Credit Card', 'Chqeque', 'Bank Transfer', 'School Credit', 'ClassTopBase Credit', 'WeChat Pay (Barcode)', 'AliPay (Barcode)', 'WeChat Pay (Web)', 'AliPay (Web)', 'WeChat Pay Transfer', 'AliPay Transfer']

export const SAAS_VERSIONS=[
  {name: 'Free Trial'},
  {name: 'Discount Plan', price: 79, billCycle: 'monthly', planCodename: 'regular_usd_monthly'},
  {name: 'Customized Plan'},
  {name: 'Basic Plan', price: 30, billCycle: 'monthly', planCodename: 'basic_30usd_monthly'},
  {name: 'Basic Plan', price: 27, billCycle: 'yearly', planCodename: 'basic_324usd_yearly'},
  {name: 'Professional Plan', price: 180, billCycle: 'monthly', planCodename: 'professional_180usd_monthly'},
  {name: 'Professional Plan', price: 162, billCycle: 'yearly', planCodename: 'professional_1944usd_yearly'},
  {name: 'Premium Plan', price: 360, billCycle: 'monthly', planCodename: 'premium_360usd_monthly'},
  {name: 'Premium Plan', price: 324, billCycle: 'yearly', planCodename: 'premium_3888usd_yearly'},
  {name: 'Customized Plan', price: 600, billCycle: 'monthly', planCodename: 'customized_600usd_monthly'},
  {name: 'Customized Plan', price: 540, billCycle: 'yearly', planCodename: 'customized_6480usd_yearly'},
  {name: 'Customized Plan', price: 800, billCycle: 'monthly', planCodename: 'customized_800usd_monthly'},
  {name: 'Customized Plan', price: 720, billCycle: 'yearly', planCodename: 'customized_8640usd_yearly'}
]



// WEBPACK FOOTER //
// ./src/data/constants.js